export const sortableColumns = {
    title: 'title'
};
